import { BookOpenCheckIcon, ClipboardCheckIcon, FolderOpenIcon, HammerIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Bonus = {
  number: string;
  title: string;
  description: string;
  benefit: string;
  value: string;
  icon: LucideIcon;
  wide?: boolean;
};

export const bonuses: Bonus[] = [
  {
    number: '01',
    title: '150 Surveying & Topography Classroom Activities',
    description:
      '150 ready-to-use activity ideas covering fundamentals, measurements, leveling, coordinates, instruments, GNSS, topographic surveys and applied surveying. Organized by difficulty level and topic.',
    benefit: 'Materials already designed for your classroom: saves hours every quarter.',
    value: 'USD 14',
    icon: FolderOpenIcon,
  },
  {
    number: '02',
    title: 'Surveying & Topography Assessment Bank',
    description:
      'Diagnostic assessments, progress activities, quizzes, tests, calculation exercises, applied scenarios, rubrics and scoring criteria for evaluating student understanding across surveying topics.',
    benefit: 'Never build an exam from scratch under pressure again.',
    value: 'USD 14',
    icon: ClipboardCheckIcon,
  },
  {
    number: '03',
    title: '50 Surveying Projects & Classroom Challenges',
    description:
      '50 fully explained project ideas and classroom challenges that help students apply surveying knowledge through practical situations, calculations, field work and problem-solving. Each includes objectives, procedures, expected outcomes and assessment criteria.',
    benefit: 'Your students finish the year with real surveying projects in their communities.',
    value: 'USD 14',
    icon: HammerIcon,
  },
  {
    number: '04',
    title: "Teacher's Surveying Reference & Terminology Handbook",
    description:
      'Teacher-focused reference handbook containing essential surveying and topography concepts, terminology, formulas and key information for quick classroom consultation. Includes definitions, contextual explanations, classroom examples and teaching recommendations.',
    benefit: 'Project it in class and your students instantly understand complex surveying concepts.',
    value: 'USD 14',
    icon: BookOpenCheckIcon,
  },
];
